
    window.smoothScroll = function(target) {
        var scrollContainer = target;
        do { //find scroll container
            scrollContainer = scrollContainer.parentNode;
            if (!scrollContainer) return;
            scrollContainer.scrollTop += 1;
        } while (scrollContainer.scrollTop == 0);

        var targetY = 0;
        do { //find the top of target relatively to the container
            if (target == scrollContainer) break;
            targetY += target.offsetTop;
        } while (target = target.offsetParent);

        scroll = function(c, a, b, i) {
            i++; if (i > 30) return;
            c.scrollTop = a + (b - a) / 30 * i;
            setTimeout(function(){ scroll(c, a, b, i); }, 20);
        }
        // start scrolling
        scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
    }


    function Section_Three_View_More(){
        var extra_card = document.getElementById("extra-card");
        var view_more = document.getElementById("section-three-view-more");
        // var image = document.getElementById("image-anchor-div");
        extra_card.classList.toggle("open-card");
        if(view_more.innerHTML === "View More"){
            view_more.innerHTML = "View Less";
            // image.style.display = "block";
            // extra_card.style.display = "block";
        }
        else{
            view_more.innerHTML = "View More";
            // image.style.display = "none";
            // extra_card.style.display = "none";
        }
    }
